/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { SvgDeveloper } from "@itwin/itwinui-icons-react";

export const SamplesButton = () => {
  return (
    <Link to="/samples" style={{ textDecoration: "none", marginLeft: "0.5rem" }} className="iui-button iui-text-muted" role="button" data-iui-size="small" data-iui-variant="borderless">
      <SvgDeveloper />
      Samples
    </Link>
  );
};
